<template>
    <div class="report-title-bar dsp-flex">
        <div class="report-title-side">
            <span v-if="fromEmbedded" class="report-title-back" @click="clickClose">
                <i class="iconfont icon-guanbi"></i>
            </span>
            <span v-else class="report-title-back" @click="clickBack">
                <i class="iconfont icon-xiangzuo"></i>
            </span>
        </div>
        <div class="report-title-mid" @click="toggleName">
            <span v-if="hideName">匿名的测评报告</span>
            <span v-else>{{detailInfo.f_name}}的测评报告</span>
        </div>
        <!-- <div v-if="fromEmbedded" class="report-title-side" @click="clickShare">
            <span class="report-title-save">分享</span>
        </div> -->
    </div>
</template>

<script>
import { SCHEME } from '../../modules/utils'
export default {
    name: 'ReportTopBar',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        detailInfo() {
            return this.$store.state.report.detailInfo;
        },
    },
    data() {
        return {
            hideName: false
        }
    },
    methods: {
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('report/resetReportData');
        },
        clickBack() {
            this.$store.dispatch('report/resetReportData');

            var curParams = this.$router.history.current.params;
            console.log('clickBack------', curParams)
            // 处理直接从八字过来的情况
            if(curParams.from && curParams.from != '') {
                if(curParams.from == 'share') {
                    this.$router.back();                    
                }else {
                    this.$router.replace('/detail/'+curParams.from+'/'+curParams.id);
                }
            }
        },
        toggleName() {

        },
        clickShare() {
            
        }
    }
}
</script>